import steps from 'pages/AutomationEngine/steps';
import { TFunction } from 'react-i18next';

import { ContextValue, SourceVariableType } from './types';
type VariableDefinitionType = any;

export const createWizardState = (step: any, defaultValue: ContextValue) => {
  if (!step) {
    return {
      ...defaultValue,
      type: steps.initializeVariable.type,
      id: `new.${steps.initializeVariable.type}.${Date.now()}`,
    };
  }
  const sourcesMask = (step?.details?.sources || []).map(
    ({ sourceType }: SourceVariableType) => sourceType
  );

  switch (step.type) {
    default:
      return {
        ...defaultValue,
        ...step.details,
        sourcesMask,
        id: step.id,
      };
  }
};

export const createPayload = (values: any, step: any) => {
  return {
    ...step,
    type: values.type,
    details: { ...values },
  };
};

export const ACTIONS_ON_FAILURE = {
  NOTIFY_CONTINUE: 'notify_continue',
  NOTIFY_PAUSE: 'notify_pause',
  SILENT_CONTINUE: 'silent_continue',
};

export const getActionOnFailureOptions = (t: TFunction) => [
  {
    label: t('Continue and Notify on Failure'),
    value: ACTIONS_ON_FAILURE.NOTIFY_CONTINUE,
  },
  {
    label: t('Pause and Notify on Failure'),
    value: ACTIONS_ON_FAILURE.NOTIFY_PAUSE,
  },
  {
    label: t('Continue on Failure and Do Not Notify'),
    value: ACTIONS_ON_FAILURE.SILENT_CONTINUE,
  },
];

export const getDefaultActionOnFailure = (stepType: VariableDefinitionType) => {
  return ACTIONS_ON_FAILURE.NOTIFY_PAUSE;
};

export const getActionOnFailureNote = (stepType: any, t: TFunction) => {
  switch (stepType) {
    case steps.modifyAutomation.type:
    case steps.modifyRelatedEntitiesAutomation.type:
    case steps.changeTags.type:
    case steps.modifyRelatedEntities.type:
      return t(
        'This step has multiple components, so it will only fail if ALL components fail.'
      );
    case steps.httpRequest.type:
      return t(
        'Anything other than 200- and 300-class responses will be considered an error.'
      );
    case steps.sendEmail.type:
      return t(
        'Emails will be marked as successful if there is an existing email that is not on the suppression list.'
      );
    case steps.createRelatedEntity.type:
      return t(
        'This will be marked as a failure if either the creation or automation execution fails, but will ignore field update failures.'
      );
    case steps.sendRelatedContactEmail.type:
      return t(
        'Emails will be marked as successful if there is at least one existing email that is not on the suppression list.'
      );
    default:
      return null;
  }
};

export const isVariableInitialization = (stepType: string, type: string = '') =>
  stepType === 'initialize_variable' || type === 'initialize_variable';
